import { AccountingBasisEffects } from './accounting-basis.effects';
import { CurrencyEffects } from './currency.effect';
import { FinancialLineItemEffects } from './financial-line-item.effects';
import { LegalFormEffects } from './legal-form.effects';
import { TranslationsEffects } from './translations.effects';
export const effects = [
    AccountingBasisEffects,
    LegalFormEffects,
    FinancialLineItemEffects,
    CurrencyEffects,
    TranslationsEffects,
];
